"use client" 
import { useState } from "react";
import InputText from "../Atoms/inputText";
import fetch from "node-fetch";
import RadioButton_1 from "../Atoms/Buttons/RadioButton_1";
import { TealButton } from "../Atoms/Buttons/ColorButtons";
import { useSearchParams } from "next/navigation";

const SignInCard = ({root, userType, lang, parent, caption, centerVertical=true}) => {
    
    const searchParams = useSearchParams()
    const searchParamsString = searchParams.toString();
     const [credentials, setCredentials] = useState('')
     const [loginFailed, setLoginFailed] = useState(false)
     const [loading, setLoading] = useState(false)
     const [selectedUserType, setSelectedUserType] = useState(userType)
   
     const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        handleSubmit()
      }
    };

     const handleSubmit = async () => {
      setLoading(true)
       console.log(credentials)
       try {
   
        let response = await fetch(`/api/auth/signin/?user_type=${selectedUserType || userType}`, {
          method: 'POST', // Use uppercase for HTTP methods
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },

          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // params: JSON.stringify(credentials)
          body: JSON.stringify(credentials) // Convert the credentials object to a JSON string
        });

        // console.log("response1", response)
        response = await response.json()
        // console.log(`response2`, response)
         // console.log(response.headers['Set-Cookie'])
           // document.cookie = `token=${response.data.token};user_first_name=${response.data.user.user_first_name};user_last_name=${response.data.user.user_last_name};user_email_address=${response.data.user.user_email_address};user_role=${response.data.user.user_role};`;
           // document.cookie = `token=${response.data.token};user=${JSON.stringify(response.data.user)}`;
           if (response.signin_success === true){
              if (window.location.href.endsWith("root") || window.location.href.endsWith("root/")) {
                if (!response.user.user_type === "ROOT") { 
                  setLoginFailed({message: "Insufficient Privileges"})
                  setLoading(false)
                }
                else {

                    // document.cookie = `token=${response.token}; path=/;`;
                    // document.cookie = `user=${JSON.stringify(response.user)}; path=/;`;
                    // document.cookie = `organization=${JSON.stringify(response.organization)}; path=/;`;
                    window.location.pathname.toLowerCase().includes("/login") ?  window.location.href = '/' : window.location.reload();
                    setLoading(false)

                }
              }
              else {
                if (userType === 'ROOT' && response.user.user_type !== 'ROOT') {
                  setLoginFailed({message: lang === 'fr' ? "Privilèges Insuffisants." : "Insufficient Privileges"})
                  setLoading(false)
                }
                else if (selectedUserType === 'RECRUITER' && (response.user.user_type !== 'RECRUITER' && response.user.user_type !== 'ROOT')) {
                  setLoginFailed({message: lang === 'fr' ? "Privilèges Insuffisants." : "Insufficient Privileges"})
                  setLoading(false)
                }
                else if (selectedUserType === 'EMPLOYER' && (response.user.user_type !== 'EMPLOYER' && response.user.user_type !== 'ROOT')) {
                  setLoginFailed({message: lang === 'fr' ? "Privilèges Insuffisants." : "Insufficient Privileges"})
                  setLoading(false)
                }
 
                else {
                  if (userType==='ROOT') {
                    // document.cookie = `token=${await response.token}; path=/;`;
                    // document.cookie = `user=${JSON.stringify(await response.user)}; path=/;`;
                    // document.cookie = `organization=${JSON.stringify(await response.organization)}; path=/;`;
                    window.location.pathname.toLowerCase().includes("/signin") ?  window.location.href = `/${lang}/employers/workspace` : window.location.reload();
                    setLoading(false)
                  }
                  else if (selectedUserType === 'RECRUITER' || selectedUserType === 'EMPLOYER') {

                    // document.cookie = `token=${await response.token}; path=/;`;
                    // document.cookie = `user=${JSON.stringify(await response.user)}; path=/;`;
                    // document.cookie = `organization=${JSON.stringify(await response.organization)}; path=/;`;

                    // window.location.pathname.toLowerCase().includes("/signin") ?  window.location.href = `/workspace` : window.location.reload();
                    if (window.location.pathname.toLowerCase().includes("/signin")) {

                      window.location.href = searchParamsString
                        ? `/workspace?${searchParamsString}`
                        : `/workspace`;
                    } else {
                      window.location.reload();
                    }
                    setLoading(false)
                  }
                  else if (selectedUserType === 'CANDIDATE') {
                    // document.cookie = `token=${await response.token}; path=/;`;
                    // document.cookie = `user=${JSON.stringify(await response.user)}; path=/;`;
                    // document.cookie = `organization=${JSON.stringify(await response.organization)}; path=/;`;
                    window.location.pathname.toLowerCase().includes("/signin") ?  window.location.href = `/talent/workspace` : window.location.reload();
                    setLoading(false)
                  }
                }
              }
            }
            else {
              setLoginFailed({message: lang === 'fr' ? 'Identification Invalide' : 'Invalid Credentials' })
              setLoading(false)
            }
   

           
       } catch (error) {
         console.log('error', error)
         setLoginFailed({message: "Invalid Login Credentials"})
       }
     }
   

     
     return (
       <>
       <div className={`flex items-center justify-center ${centerVertical && 'min-h-screen'}`}> 
         <div className="w-full max-w-sm p-4 bg-white shadow-xl rounded-3xl shadow sm:p-6 md:p-8 dark:bg-slate-700 dark:border-gray-700 space-y-4 font-inter">
           {/* <form className="space-y-6" onSubmit={handleSubmit} method="POST"> */}
             <h5 className="text-2xl text-teal-400 dark:text-teal-400">
               {caption ? <span>{caption}</span> : <><span className="dark:text-white text-slate-300">Talnet</span> <span className="font-semibold text-teal-400">{lang === 'fr' ? 'Connexion' : 'Sign in'}</span></>}
             </h5>

             {userType !== 'ROOT' && <RadioButton_1
                          name="userTypeRadioSwitch"
                          value1="RECRUITER"
                          value2="EMPLOYER"
                          caption1={lang === 'fr' ? "Recruteur" : "Recruiter"}
                          caption2={lang === 'fr' ? "Employeur" : "Employer"}
                          defaultChecked={'RECRUITER'}
                          callback={(x)=>{setSelectedUserType(x.user_type)}}
                          callbackObjectKey={'user_type'}
                        />}
              
             <div>

                         <InputText darkBGValue={'dark:bg-slate-700'} data={{
               type: 'email',
               id: 'user_email_address',
               onChange:(x)=>{setCredentials({...credentials, user_email_address: x.target.value})},
               label: lang === 'fr' ? 'Votre Adresse Courriel' : 'Your Email Address',
               value: credentials.user_email_address || ''
               }}/>
             </div>
             <div>
              
   <InputText 
   darkBGValue={'dark:bg-slate-700'}
 onKeyDown={handleKeyDown}
   data={{
               type: 'password',
               id: 'user_password',
               onChange:(x)=>{setCredentials({...credentials, user_password: x.target.value})},
               label: lang === 'fr' ? 'Votre Mot de Passe' : 'Your Password',
               value: credentials.user_password || ''
               }}/>
             </div>
             <div className="flex items-start">
               {/* <div className="flex items-start">
                 <div className="flex items-center h-5">
                   <input
                     id="remember"
                     type="checkbox"
                     value=""
                     className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-indigo-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-indigo-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800"
                     required
                   />
                 </div>
                 <label
                   for="remember"
                   className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                 >
                   Remember me
                 </label>
               </div> */}
                    <div className="flex items-start">
                 <div className="flex items-center h-5">
   
                 </div>
                 <label
                   htmlFor="remember"
                   className={`ml-2 text-sm font-medium text-red-600 dark:text-red-300 ${loginFailed ? 'block' : 'hidden'}`}
                 >
                   {loginFailed?.message}
                 </label>
               </div>
   
               {!root && (<a
                 href="mailto:talnet@talnet.co?subject=Password Reset Request&body=Hello, please reset my password."
                 className={`ml-auto text-sm text-teal-500 hover:underline dark:text-teal-500`}
               >
                 {lang === 'fr' ? 'Mot de Passe Oublié ?' : 'Lost Password?'}
               </a>)}
             </div>

             <TealButton loading={loading} onClick={handleSubmit} border={true} textSize={'text-sm'} caption={lang === 'fr' ? 'Connexion' : 'Sign-in'}/>
             {/* <button
             disabled={loading ? true : false}
  type="submit"
  onClick={handleSubmit}
  className={`w-full flex items-center justify-center text-white ${loading ? 'bg-gray-400': 'bg-indigo-700 dark:bg-indigo-600'} hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5  dark:hover:bg-indigo-700 dark:focus:ring-indigo-800 ease-in-out duration-500`}
>
{loading ? <><div className="loader bg-white mr-2"></div>
  <span>{lang === 'fr' ? 'Chargement' : 'Loading'}</span></> : 
  lang === 'fr' ? 'Se connecter' : 'Sign-in to your account'
}
</button> */}
             {!root && (<div className="text-sm font-medium text-gray-500 dark:text-gray-300">
               {lang === 'fr' ? `Vous n'avez pas de compte? ` : `Not registered? `}
               <a
                 href={`/auth/signup`}
                 className="text-teal-500 hover:underline dark:text-teal-500"
               >
                 {lang === 'fr' ? 'Créer un compte gratuit' : 'Create a free account'}
               </a>
             </div>)}
           {/* </form> */}
         </div>
         </div>
       </>
     );
   };

export default SignInCard






























// "use client" 
// import { useState } from "react";
// import InputText from "../Atoms/inputText";
// import fetch from "node-fetch";
// import RadioButton_1 from "../Atoms/Buttons/RadioButton_1";
// import { TealButton } from "../Atoms/Buttons/ColorButtons";

// const SignInCard = ({root, userType, lang, parent, caption, centerVertical=true}) => {

//      const [credentials, setCredentials] = useState('')
//      const [loginFailed, setLoginFailed] = useState(false)
//      const [loading, setLoading] = useState(false)
//      const [selectedUserType, setSelectedUserType] = useState(userType)
   
//      const handleKeyDown = (e) => {
//       if (e.key === 'Enter') {
//         handleSubmit()
//       }
//     };

//      const handleSubmit = async () => {
//       setLoading(true)
//        console.log(credentials)
//        try {
   
//         let response = await fetch(`/api/auth/signin/?user_type=${selectedUserType || userType}`, {
//           method: 'POST', // Use uppercase for HTTP methods
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },

//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//           // params: JSON.stringify(credentials)
//           body: JSON.stringify(credentials) // Convert the credentials object to a JSON string
//         });

//         response = await response.json()
//         console.log(`rez`, response)
//          // console.log(response.headers['Set-Cookie'])
//            // document.cookie = `token=${response.data.token};user_first_name=${response.data.user.user_first_name};user_last_name=${response.data.user.user_last_name};user_email_address=${response.data.user.user_email_address};user_role=${response.data.user.user_role};`;
//            // document.cookie = `token=${response.data.token};user=${JSON.stringify(response.data.user)}`;
//            if (response.signin_success === true){
//               if (window.location.href.endsWith("root") || window.location.href.endsWith("root/")) {
//                 if (!response.user.user_type === "ROOT") { 
//                   setLoginFailed({message: "Insufficient Privileges"})
//                   setLoading(false)
//                 }
//                 else {

//                     document.cookie = `token=${response.token}; path=/;`;
//                     document.cookie = `user=${JSON.stringify(response.user)}; path=/;`;
//                     // document.cookie = `organization=${JSON.stringify(response.organization)}; path=/;`;
//                     window.location.pathname.toLowerCase().includes("/login") ?  window.location.href = '/' : window.location.reload();
//                     setLoading(false)

//                 }
//               }
//               else {
//                 if (userType === 'ROOT' && response.user.user_type !== 'ROOT') {
//                   setLoginFailed({message: lang === 'fr' ? "Privilèges Insuffisants." : "Insufficient Privileges"})
//                   setLoading(false)
//                 }
//                 else if (selectedUserType === 'RECRUITER' && response.user.user_type !== 'RECRUITER' && response.user.user_type !== 'ROOT') {
//                   setLoginFailed({message: lang === 'fr' ? "Privilèges Insuffisants." : "Insufficient Privileges"})
//                   setLoading(false)
//                 }
//                 else if (selectedUserType === 'EMPLOYER' && response.user.user_type !== 'EMPLOYER' && response.user.user_type !== 'ROOT') {
//                   setLoginFailed({message: lang === 'fr' ? "Privilèges Insuffisants." : "Insufficient Privileges"})
//                   setLoading(false)
//                 }
 
//                 else {
//                   if (userType==='ROOT') {
//                     document.cookie = `token=${await response.token}; path=/;`;
//                     document.cookie = `user=${JSON.stringify(await response.user)}; path=/;`;
//                     // document.cookie = `organization=${JSON.stringify(await response.organization)}; path=/;`;
//                     window.location.pathname.toLowerCase().includes("/signin") ?  window.location.href = `/${lang}/employers/workspace` : window.location.reload();
//                     setLoading(false)
//                   }
//                   else if (selectedUserType === 'RECRUITER' || selectedUserType === 'EMPLOYER') {
//                     document.cookie = `token=${await response.token}; path=/;`;
//                     document.cookie = `user=${JSON.stringify(await response.user)}; path=/;`;
//                     // document.cookie = `organization=${JSON.stringify(await response.organization)}; path=/;`;
//                     window.location.pathname.toLowerCase().includes("/signin") ?  window.location.href = `/workspace` : window.location.reload();
//                     setLoading(false)
//                   }
//                   else if (selectedUserType === 'CANDIDATE') {
//                     document.cookie = `token=${await response.token}; path=/;`;
//                     document.cookie = `user=${JSON.stringify(await response.user)}; path=/;`;
//                     // document.cookie = `organization=${JSON.stringify(await response.organization)}; path=/;`;
//                     window.location.pathname.toLowerCase().includes("/signin") ?  window.location.href = `/talent/workspace` : window.location.reload();
//                     setLoading(false)
//                   }
//                 }
//               }
//             }
//             else {
//               setLoginFailed({message: lang === 'fr' ? 'Identification Invalide' : 'Invalid Credentials' })
//               setLoading(false)
//             }
   

           
//        } catch (error) {
//          console.log('error', error)
//          setLoginFailed({message: "Invalid Login Credentials"})
//        }
//      }
   

     
//      return (
//        <>
//        <div className={`flex items-center justify-center ${centerVertical && 'min-h-screen'}`}> 
//          <div className="w-full max-w-sm p-4 bg-white shadow-xl rounded-3xl shadow sm:p-6 md:p-8 dark:bg-slate-700 dark:border-gray-700 space-y-4 font-inter">
//            {/* <form className="space-y-6" onSubmit={handleSubmit} method="POST"> */}
//              <h5 className="text-2xl text-teal-400 dark:text-teal-400">
//                {caption ? <span>{caption}</span> : <><span className="dark:text-white text-slate-300">Talnet</span> <span className="font-semibold text-teal-400">{lang === 'fr' ? 'Connexion' : 'Sign in'}</span></>}
//              </h5>

//              {userType !== 'ROOT' && <RadioButton_1
//                           name="userTypeRadioSwitch"
//                           value1="RECRUITER"
//                           value2="EMPLOYER"
//                           caption1={lang === 'fr' ? "Recruteur" : "Recruiter"}
//                           caption2={lang === 'fr' ? "Employeur" : "Employer"}
//                           defaultChecked={'RECRUITER'}
//                           callback={(x)=>{setSelectedUserType(x.user_type)}}
//                           callbackObjectKey={'user_type'}
//                         />}
              
//              <div>

//                          <InputText darkBGValue={'dark:bg-slate-700'} data={{
//                type: 'email',
//                id: 'user_email_address',
//                onChange:(x)=>{setCredentials({...credentials, user_email_address: x.target.value})},
//                label: lang === 'fr' ? 'Votre Adresse Courriel' : 'Your Email Address',
//                value: credentials.user_email_address || ''
//                }}/>
//              </div>
//              <div>
              
//    <InputText 
//    darkBGValue={'dark:bg-slate-700'}
//  onKeyDown={handleKeyDown}
//    data={{
//                type: 'password',
//                id: 'user_password',
//                onChange:(x)=>{setCredentials({...credentials, user_password: x.target.value})},
//                label: lang === 'fr' ? 'Votre Mot de Passe' : 'Your Password',
//                value: credentials.user_password || ''
//                }}/>
//              </div>
//              <div className="flex items-start">
//                {/* <div className="flex items-start">
//                  <div className="flex items-center h-5">
//                    <input
//                      id="remember"
//                      type="checkbox"
//                      value=""
//                      className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-indigo-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-indigo-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800"
//                      required
//                    />
//                  </div>
//                  <label
//                    for="remember"
//                    className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
//                  >
//                    Remember me
//                  </label>
//                </div> */}
//                     <div className="flex items-start">
//                  <div className="flex items-center h-5">
   
//                  </div>
//                  <label
//                    htmlFor="remember"
//                    className={`ml-2 text-sm font-medium text-red-600 dark:text-red-300 ${loginFailed ? 'block' : 'hidden'}`}
//                  >
//                    {loginFailed?.message}
//                  </label>
//                </div>
   
//                {!root && (<a
//                  href="#"
//                  className={`ml-auto text-sm text-teal-500 hover:underline dark:text-teal-500`}
//                >
//                  {lang === 'fr' ? 'Mot de Passe Oublié ?' : 'Lost Password?'}
//                </a>)}
//              </div>

//              <TealButton loading={loading} onClick={handleSubmit} border={true} textSize={'text-sm'} caption={lang === 'fr' ? 'Connexion' : 'Sign-in'}/>
//              {/* <button
//              disabled={loading ? true : false}
//   type="submit"
//   onClick={handleSubmit}
//   className={`w-full flex items-center justify-center text-white ${loading ? 'bg-gray-400': 'bg-indigo-700 dark:bg-indigo-600'} hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5  dark:hover:bg-indigo-700 dark:focus:ring-indigo-800 ease-in-out duration-500`}
// >
// {loading ? <><div className="loader bg-white mr-2"></div>
//   <span>{lang === 'fr' ? 'Chargement' : 'Loading'}</span></> : 
//   lang === 'fr' ? 'Se connecter' : 'Sign-in to your account'
// }
// </button> */}
//              {!root && (<div className="text-sm font-medium text-gray-500 dark:text-gray-300">
//                {lang === 'fr' ? `Vous n'avez pas de compte? ` : `Not registered? `}
//                <a
//                  href={`/auth/signup`}
//                  className="text-teal-500 hover:underline dark:text-teal-500"
//                >
//                  {lang === 'fr' ? 'Créer un compte' : 'Create an account'}
//                </a>
//              </div>)}
//            {/* </form> */}
//          </div>
//          </div>
//        </>
//      );
//    };

// export default SignInCard